<template>
  <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
    <div class="container fadeUp" :class="animate ? 'animate' : ''">
      <div class="breadcrumb">
        <router-link
          :to="url.full_url"
          class="font-12"
          v-for="(url, index) in breadCrumbs"
          :key="index"
          :class="
            breadCrumbs.length - 1 == index && !_.get($store.state.selected_menu, 'routeParams.singleview')
              ? 'active': ''
          "
          v-if="!_.includes(url.css, 'disable-from-breadcrumbs')"
          >{{ url.title }}</router-link>
      </div>
    </div>
  </intersect>
</template>

<script>
import mainMixin from "@/mixins/main";
import Intersect from "vue-intersect";

export default {
  components: { Intersect },
  mixins: [mainMixin],
  data() {
    return {
      breadcrumb: [],
      animate: false,
    };
  },
  computed: {
    breadCrumbs(){
      return this.getBreadCrumbs(this.$store.state.selected_menu);

    }
  },
  mounted() {},
  methods: {},
};
</script>
